import { useSelector } from 'react-redux'
import RootState from 'store/state'

export default function useDirectory() {
    const directory = useSelector<RootState, RootState['directory']>(({ directory }) => directory)

    return directory
}
